import { render, staticRenderFns } from "./PaymentDropdown.vue?vue&type=template&id=548d3924&scoped=true"
import script from "./PaymentDropdown.vue?vue&type=script&lang=js"
export * from "./PaymentDropdown.vue?vue&type=script&lang=js"
import style0 from "./PaymentDropdown.vue?vue&type=style&index=0&id=548d3924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d3924",
  null
  
)

export default component.exports